import e, { createContext as z, useState as x, useContext as R, useMemo as C, useCallback as _, useEffect as E } from "react";
import { View as c, Text as p, Button as S, Tags as D, Compact as Z, Label as q } from "@vectord/ui";
import ee from "react-select";
import te from "@vectord/transition-card";
import { useApplyFiltersMutation as ne, useGetFiltersQuery as re } from "./filter-services.js";
const $ = z({
  currentStage: "intro",
  setCurrentStage: () => {
  }
}), le = ({ children: t }) => {
  const [n, o] = x("intro");
  return /* @__PURE__ */ e.createElement($.Provider, { value: { currentStage: n, setCurrentStage: o } }, t);
}, W = z({
  profile: null,
  setProfile: () => {
  }
}), oe = ({ children: t }) => {
  const [n, o] = x(null);
  return /* @__PURE__ */ e.createElement(W.Provider, { value: { profile: n, setProfile: o } }, t);
}, B = z({
  formOriginContext: null,
  setFormOriginContext: () => {
  },
  filterOptions: null,
  setFilterOptions: () => {
  },
  formState: null,
  setFormState: () => {
  }
}), ae = ({ children: t }) => {
  const [n, o] = x(null), [r, a] = x(null), [l, s] = x(null);
  return /* @__PURE__ */ e.createElement(B.Provider, { value: {
    formState: r,
    setFormState: a,
    filterOptions: n,
    setFilterOptions: o,
    formOriginContext: l,
    setFormOriginContext: s
  } }, t);
}, w = () => R($), b = () => R(B), k = () => R(W), M = "https://d2beiqkhq929f0.cloudfront.net/public_assets/assets/000/075/611/original/_avatar.webp?1717056076", U = "https://d2beiqkhq929f0.cloudfront.net/public_assets/assets/000/075/622/original/Progress_Bar_Line_remix_crop.gif?1717063098", se = "https://d2beiqkhq929f0.cloudfront.net/public_assets/assets/000/077/111/original/_shift.svg?1717754190", ie = () => /* @__PURE__ */ e.createElement(c, { className: "vd-flex-col sm:vd-px-64 sm:vd-py-20 vd-justify-center vd-flex-1 vd-mb-16 sm:vd-mb-0" }, /* @__PURE__ */ e.createElement(c, null, /* @__PURE__ */ e.createElement("img", { src: M, alt: "intro image", className: "vd-w-80 sm:vd-w-120 vd-h-80 sm:vd-h-120" })), /* @__PURE__ */ e.createElement(c, { className: "vd-mt-12 sm:vd-mt-40 vd-flex-col" }, /* @__PURE__ */ e.createElement(p, { fontSize: "h1", color: "text-neutral-disabled" }, "Hello!"), /* @__PURE__ */ e.createElement(p, { fontSize: "h1", weight: "bold", color: "text-neutral-primary" }, "Do you wish to connect with people just like you?")), /* @__PURE__ */ e.createElement(c, { className: "vd-mt-16 sm:vd-mt-28" }, /* @__PURE__ */ e.createElement(p, { fontSize: "b1", color: "text-neutral-tertiary" }, "If yes, then give us your few details and help us finding right profiles that matches your career aspirations"))), F = [
  {
    id: "student",
    title: "Student",
    desc: "You are studying at a university or other place of higher education."
  },
  {
    id: "professional",
    title: "Working Professional",
    desc: "Currently working full-time/part-time for a business organisation."
  }
];
function ce() {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}
function A() {
  return /tablet|iPad/i.test(navigator.userAgent) ? "tablet" : ce() ? "mobile" : "desktop";
}
function de() {
  let t;
  if (document.cookie.match(/_ga=(.+?);/)) {
    const n = /_ga=(.+?);/;
    t = document.cookie.match(n)[1].split(
      "."
    ).slice(-2).join(".");
  }
  return t;
}
const me = (t) => {
  const o = document.cookie.split(";").find(
    (a) => a.trim().startsWith(`${t}=`)
  ), r = o == null ? void 0 : o.split("=").slice(1).join("=");
  return r ? decodeURIComponent(r) : void 0;
}, ue = (t) => {
  typeof window.dataLayer < "u" && window.dataLayer.push(t);
};
function pe(t) {
  if (!t)
    return {};
  let n = t;
  t.startsWith("/") && (n = window.location.origin + t);
  try {
    const o = new URL(n);
    let r = o.pathname;
    return r.endsWith("/") || (r += "/"), {
      destination_url: o.href,
      destination_host: o.host,
      destination_path: r
    };
  } catch {
    return {};
  }
}
function fe({
  element: t,
  link: n,
  text: o,
  category: r,
  ...a
}) {
  const l = o ? o.substring(0, 999) : void 0, s = {
    element: t,
    text: l,
    ...a
  }, u = pe(n), i = {
    ...s,
    ...u
  };
  ue({
    event: "gtm_custom_click",
    category: "personalisation-modal",
    label: t,
    action: "gtm_custom_click",
    attributes: i
  });
}
function g(t, n, o) {
  const r = n || t, a = window.trackingUserData, l = window.location.href;
  fe({
    element: r,
    ...o || {},
    ...a,
    link: l
  });
}
function ve(t) {
  const n = /* @__PURE__ */ new Date(), o = n.getTimezoneOffset();
  window.trackingUserData = {
    cu_date: n,
    cu_timezone_offset: o,
    user_analytics_identifier: me("user_analytics_identifier"),
    google_client_id: de(),
    request_source: A(),
    device: A(),
    user_id: t,
    company: "scaler",
    product: "Alumni Directory",
    subproduct: "filter-recommendation"
  };
}
const ge = ({ onProfileSelect: t }) => {
  const { profile: n, setProfile: o } = k(), { setCurrentStage: r } = w(), a = () => (t(n), g("cta", "personalisation-modal", {
    click_type: "alumni_personalised_modal_you_are",
    click_text: n
  }), r(n === "student" ? "student" : "professional-first")), l = (s) => {
    o(s.id), g("cta", "personalisation-modal", {
      click_type: `alumni_personalised_modal_you_are_${s.title}`,
      click_text: s.title
    });
  };
  return /* @__PURE__ */ e.createElement(c, { className: "vd-shadow-d-32l vd-flex-col vd-py-20 vd-px-16 sm:vd-px-32 vd-flex-1" }, /* @__PURE__ */ e.createElement(p, { fontSize: "h2", color: "text-neutral-primary" }, "You're a"), /* @__PURE__ */ e.createElement(c, { className: "vd-gap-y-20 vd-mt-28 vd-flex-col vd-mb-40" }, F.map(
    (s) => /* @__PURE__ */ e.createElement(
      c,
      {
        key: s.id,
        className: `
              vd-border-solid vd-cursor-pointer vd-p-16 sm:vd-p-24
              ${s.id === n ? "vd-border-border-brand-bold vd-bg-background-brand-subtlest" : "vd-border-border-neutral-subtlest"}
            `,
        onClick: () => l(s)
      },
      /* @__PURE__ */ e.createElement(c, { className: "vd-self-center vd-flex-col vd-gap-y-8 " }, /* @__PURE__ */ e.createElement(p, { fontSize: "h2", weight: "bold", color: "text-neutral-primary" }, s.title), /* @__PURE__ */ e.createElement(p, { fontSize: "b2", color: "text-neutral-tertiary" }, s.desc))
    )
  )), /* @__PURE__ */ e.createElement(
    S,
    {
      buttonType: "outline",
      iconRight: "arrow-up-right",
      size: "l",
      title: "Next",
      variants: n ? "brand" : "disabled",
      onClick: a,
      disabled: !n
    }
  ));
}, O = ({ className: t = "" }) => /* @__PURE__ */ e.createElement(c, { className: `vd-shadow-d-32l vd-flex-col vd-py-20 vd-px-16 sm:vd-px-32 
      vd-flex-1 vd-items-center vd-justify-center vd-gap-y-8 ${t}` }, /* @__PURE__ */ e.createElement("img", { src: U, alt: "loading", className: "vd-h-40" }), /* @__PURE__ */ e.createElement(p, { fontSize: "b1", color: "text-neutral-tertiary" }, "Loading...")), I = ({ onError: t = () => {
}, showButton: n = !0 }) => {
  const { formOriginContext: o } = b(), r = o === "all-filters" ? "personalisation-modal" : "personalisation-on-fp", a = o === "all-filters" ? "alumni_personalised_modal_error_try_again" : "alumni__on_fp_personalised_error_try_again";
  return /* @__PURE__ */ e.createElement(c, { className: "vd-shadow-d-32l vd-flex-col vd-py-20 vd-px-16 sm:vd-px-32 vd-flex-1 vd-items-center vd-justify-center vd-gap-y-16" }, /* @__PURE__ */ e.createElement(p, { fontSize: "b1", color: "text-neutral-tertiary" }, "Something went wrong!!!"), n && /* @__PURE__ */ e.createElement(
    S,
    {
      onClick: () => {
        g(
          "cta",
          r,
          {
            click_type: a
          }
        ), t();
      },
      buttonType: "solid",
      size: "l",
      title: "try again",
      variants: "brand"
    }
  ));
}, ye = [
  {
    id: "audience",
    type: "dropdown",
    placeholder: "I am a",
    label: "I am a",
    options: ["Student", "Professional"],
    isSelected: null,
    trackingName: "you_are"
  },
  {
    id: "profile",
    type: "dropdown",
    placeholder: "Select your profile",
    label: "What best describes your profile?",
    options: ["CS Background", "Non CS Profile", "Non Tech"],
    isSelected: null,
    trackingName: "your_profile"
  },
  {
    id: "post_academy_segment",
    type: "dropdown",
    label: "What best defines your target company segment?",
    placeholder: "Dream company",
    options: [],
    isSelected: null,
    trackingName: "dream_segment"
  }
], be = [
  {
    id: "profile",
    type: "radio",
    label: "What best describes your profile?",
    options: ["CS Background", "Non CS Profile", "Non Tech"],
    isSelected: null,
    trackingName: "your_profile"
  },
  {
    id: "experience",
    type: "dropdown",
    label: "How many years of working experience you have?",
    placeholder: "Select experience",
    options: [],
    isSelected: null,
    trackingName: "years_experience"
  },
  {
    id: "pre_scaler_role_type",
    type: "dropdown",
    label: "What is your current role?",
    placeholder: "Select role",
    options: [],
    isSelected: null,
    trackingName: "current_role"
  },
  {
    id: "post_scaler_role_type",
    type: "dropdown",
    label: "What best defines your target role?",
    placeholder: "Select target role",
    options: [],
    isSelected: null,
    trackingName: "target_role",
    excludedOptions: ["Non Tech background", "Freshers + CS / non-CS background"]
  },
  {
    id: "pre_academy_segment",
    type: "dropdown",
    label: "What best defines your current company?",
    placeholder: "Select company",
    options: [],
    isSelected: null,
    trackingName: "current_segment",
    excludedOptions: ["Student or Fresher"]
  },
  {
    id: "post_academy_segment",
    type: "dropdown",
    label: "What best defines your target company segment?",
    placeholder: "Select company",
    options: [],
    isSelected: null,
    trackingName: "dream_segment"
  }
], he = [
  {
    id: "profile",
    type: "radio",
    label: "What best describes your profile?",
    options: ["CS Background", "Non CS Profile", "Non Tech"],
    isSelected: null,
    trackingName: "your_profile"
  },
  {
    id: "tier",
    type: "radio",
    label: "What kind of college did you go to?",
    options: ["Tier 1 College", "Tier 2 College", "Tier 3 College"],
    isSelected: null,
    trackingName: "college_tier"
  },
  {
    id: "post_academy_segment",
    type: "dropdown",
    label: "What your dream company segment?",
    placeholder: "Select target company",
    options: [],
    isSelected: null,
    trackingName: "dream_segment"
  }
], _e = {
  student: he,
  professional: be,
  fp: ye
}, Q = (t, n, o) => {
  const r = n === "dropdown" ? t.map((a) => ({ label: a, value: a })) : t;
  return o ? r.filter((a) => !o.includes(a.label)) : r;
}, L = (t, n) => {
  const o = [], r = (a) => a.map(({ id: l, type: s, options: u, excludedOptions: i, ...d }) => ({
    ...d,
    id: l,
    type: s,
    options: Q(t[l] || u, s, i)
  }));
  return n.forEach((a) => o.push(
    r(_e[a]) || []
  )), o;
}, Se = (t) => {
  const { isError: n, isLoading: o, isSuccess: r, refetch: a } = t, { filterOptions: l, setFormState: s } = b(), [
    u,
    i
  ] = C(() => l && Object.keys(l).length ? L(l, ["student", "professional"]) : [[], []], [l]), d = _(() => {
    a();
  }, [a]), m = _((v) => {
    s(v === "student" ? u : i);
  }, [i, s, u]), f = () => {
    if (n)
      return /* @__PURE__ */ e.createElement(I, { onError: d });
    if (o)
      return /* @__PURE__ */ e.createElement(O, null);
    if (r)
      return /* @__PURE__ */ e.createElement(ge, { onProfileSelect: m });
  };
  return /* @__PURE__ */ e.createElement(c, { className: "vd-flex-col sm:vd-flex-row vd-p-8 sm:vd-px-28 sm:vd-py-28 vd-bg-background-neutral-subtlest" }, /* @__PURE__ */ e.createElement(ie, null), f());
}, xe = () => {
  var a;
  const { currentStage: t, setCurrentStage: n } = w(), { profile: o } = k(), r = ((a = F.find(
    (l) => l.id === o
  )) == null ? void 0 : a.title) || "";
  return /* @__PURE__ */ e.createElement(c, { className: "vd-flex-col sm:vd-px-64 sm:vd-py-20 vd-gap-y-40 vd-flex-1" }, /* @__PURE__ */ e.createElement(c, null, t === "professional-second" ? /* @__PURE__ */ e.createElement(
    S,
    {
      onClick: () => {
        g("cta", "personalisation-modal", {
          click_type: "alumni_personalised_modal_profile_edit_button"
        }), n("professional-first");
      },
      className: "vd-w-fit",
      buttonType: "outline",
      iconRight: "arrow-left",
      size: "l",
      variants: "neutral"
    }
  ) : null, t !== "professional-second" ? /* @__PURE__ */ e.createElement(
    S,
    {
      onClick: () => {
        g("cta", "personalisation-modal", {
          click_type: "alumni_personalised_modal_professional_back_button"
        }), n("intro");
      },
      className: "sm:vd-hidden vd-w-fit",
      buttonType: "outline",
      iconRight: "arrow-left",
      size: "l",
      variants: "neutral"
    }
  ) : null), /* @__PURE__ */ e.createElement(c, { className: "vd-hidden sm:vd-flex" }, /* @__PURE__ */ e.createElement("img", { src: M, alt: "intro image" })), /* @__PURE__ */ e.createElement(p, { fontSize: "h1", color: "text-neutral-disabled", className: "vd-hidden sm:vd-flex" }, "Provide us your information so that we can help you connect with people like you?"), /* @__PURE__ */ e.createElement(c, { className: "vd-flex-row vd-gap-x-12 vd-items-center vd-hidden sm:vd-flex" }, /* @__PURE__ */ e.createElement(p, { fontSize: "b1", weight: "bold", color: "text-neutral-primary" }, "You're a"), /* @__PURE__ */ e.createElement(
    D,
    {
      onClick: () => {
        g("cta", "personalisation-modal", {
          click_type: "alumni_personalised_modal_profile_edit_button"
        }), n("intro");
      },
      iconRight: "pencil-simple",
      label: r,
      tagSize: "l",
      tagType: "fill",
      tagVariant: "neutral",
      type: "line"
    }
  )));
}, Y = (t, n) => {
  const { options: o, isSelected: r } = t;
  return o.map(
    (a) => /* @__PURE__ */ e.createElement(
      D,
      {
        key: a,
        onClick: () => n(a),
        label: a,
        tagSize: "m",
        tagType: "fill",
        tagVariant: "neutral",
        active: r === a
      }
    )
  );
}, H = (t, n) => {
  const { options: o, isSelected: r, placeholder: a } = t;
  return /* @__PURE__ */ e.createElement(
    ee,
    {
      placeholder: a,
      menuPortalTarget: document.body,
      styles: {
        container: (l) => ({
          ...l,
          flexGrow: 1,
          width: "100%",
          borderColor: "#d4d4d4"
        }),
        control: (l) => ({
          ...l,
          height: 48,
          borderRadius: 0,
          color: "#616161"
        }),
        menuPortal: (l) => ({
          ...l,
          zIndex: 9999
        }),
        option: (l, s) => ({
          ...l,
          fontSize: 16,
          color: "#61738e",
          paddingRight: 24,
          paddingLeft: 24,
          paddingTop: 12,
          paddingBottom: 12,
          ...s.isFocused ? {
            backgroundColor: "#f4f6f9",
            fontWeight: 600
          } : {},
          ...s.isSelected ? {
            backgroundColor: "#e6f2ff",
            color: "#0080ff",
            fontWeight: 600
          } : {}
        }),
        singleValue: (l) => ({
          ...l,
          color: "#61738e"
        })
      },
      value: r,
      defaultValue: r,
      onChange: n,
      options: o
    }
  );
}, j = ({
  question: t,
  onQuestionClick: n
}) => {
  const { formState: o, setFormState: r } = b(), { profile: a } = k(), { id: l, type: s, trackingName: u } = t, i = _((d) => {
    const m = o.map((f) => f.id === l ? { ...f, isSelected: d } : f);
    g("cta", "personalisation-modal", {
      click_type: `alumni_personalised_modal_${a}_${u}`,
      click_text: (d == null ? void 0 : d.value) || d
    }), r(m), n && n(d, m);
  }, [o, l, n, a, r, u]);
  return /* @__PURE__ */ e.createElement(c, { className: "vd-flex-wrap sm:vd-flex-row vd-gap-x-16 vd-gap-y-16" }, s === "radio" ? Y(t, i) : H(t, i));
}, Ee = () => {
  const { formState: t } = b(), { setCurrentStage: n } = w(), o = C(
    () => t.length && t.every((r) => r.isSelected !== null),
    [t]
  );
  return t.length === 0 ? null : /* @__PURE__ */ e.createElement(c, { className: "sm:vd-shadow-d-32l vd-flex-col sm:vd-py-20 sm:vd-px-32 vd-gap-32 vd-flex-1" }, t.map(
    (r) => /* @__PURE__ */ e.createElement(c, { key: r.id, className: "vd-flex-col vd-gap-12 vd-w-full" }, /* @__PURE__ */ e.createElement(p, { fontSize: "h2", weight: "bold", color: "text-neutral-primary" }, r.label), /* @__PURE__ */ e.createElement(j, { question: r }))
  ), /* @__PURE__ */ e.createElement(
    S,
    {
      onClick: () => {
        g("cta", "personalisation-modal", {
          click_type: "alumni_personalised_modal_student_find_profile_button"
        }), n("response");
      },
      buttonType: "solid",
      iconRight: "arrow-up-right",
      size: "l",
      title: "find matching profiles",
      variants: o ? "brand" : "disabled",
      disabled: !o
    }
  ));
};
function we(t, n, o = !1) {
  const { key: r, values: a } = t[0], l = n.findIndex((d) => d.id === r), s = n[l], u = o ? a : a.concat(s.form), i = {
    ...s,
    options: u
  };
  return n.splice(l, 1, i), n;
}
function ke(t, n, o) {
  const { key: r, values: a } = t[0], l = n.findIndex((m) => m.id === r), s = n[l], i = Q(o[r], s.type, s.excludedOptions).filter((m) => a.findIndex(
    (f) => f.label === m.label
  ) === -1), d = {
    ...s,
    options: i
  };
  return n.splice(l, 1, d), n;
}
const Ne = {
  "CS Background": {
    excluded: [
      {
        key: "pre_scaler_role_type",
        values: [
          {
            label: "Non Tech background",
            value: "Non Tech background"
          },
          {
            label: "Freshers + CS / non-CS background",
            value: "Freshers + CS / non-CS background"
          }
        ]
      }
    ]
  },
  "Non CS Profile": {
    included: [
      {
        key: "pre_scaler_role_type",
        values: [
          {
            label: "Non CS Role",
            value: "Non CS Role"
          },
          {
            label: "Others",
            value: "Others"
          }
        ]
      }
    ]
  },
  "Non Tech": {
    included: [
      {
        key: "pre_scaler_role_type",
        values: [
          {
            label: "Non Tech Role",
            value: "Non Tech Role"
          },
          {
            label: "Others",
            value: "Others"
          }
        ]
      }
    ]
  }
}, Ce = () => {
  const { formState: t, setFormState: n, filterOptions: o } = b(), { setCurrentStage: r } = w(), a = C(
    () => t.length && t.slice(0, 3).every((s) => s.isSelected !== null),
    [t]
  ), l = _((s, u) => {
    const i = Ne[s];
    let [d] = L(o, ["professional"]);
    d.splice(0, 1, u[0]), i.excluded && (d = ke(
      i.excluded,
      d,
      o
    )), i.included && (d = we(
      i.included,
      d,
      !0
    )), d && n(d);
  }, [o, n]);
  return t.length === 0 ? null : /* @__PURE__ */ e.createElement(c, { className: "sm:vd-shadow-d-32l vd-flex-col sm:vd-py-20 sm:vd-px-32 vd-gap-32 vd-flex-1" }, t.slice(0, 3).map(
    (s) => /* @__PURE__ */ e.createElement(c, { key: s.id, className: "vd-flex-col vd-gap-12" }, /* @__PURE__ */ e.createElement(p, { fontSize: "h2", weight: "bold", color: "text-neutral-primary" }, s.label), /* @__PURE__ */ e.createElement(
      j,
      {
        question: s,
        onQuestionClick: s.id === "profile" ? (u, i) => l(u, i) : () => {
        }
      }
    ))
  ), /* @__PURE__ */ e.createElement(
    S,
    {
      onClick: () => {
        g("cta", "personalisation-modal", {
          click_type: "alumni_personalised_modal_professional_next_button"
        }), r("professional-second");
      },
      buttonType: "outline",
      iconRight: "arrow-up-right",
      size: "l",
      title: "Next",
      variants: a ? "brand" : "disabled",
      disabled: !a
    }
  ));
}, Fe = () => {
  const { formState: t } = b(), { setCurrentStage: n } = w(), o = C(
    () => t.length && t.every((r) => r.isSelected !== null),
    [t]
  );
  return t.length === 0 ? null : /* @__PURE__ */ e.createElement(c, { className: "sm:vd-shadow-d-32l vd-flex-col sm:vd-py-20 sm:vd-px-32 vd-gap-32 vd-flex-1" }, t.slice(3, 6).map(
    (r) => /* @__PURE__ */ e.createElement(c, { key: r.id, className: "vd-flex-col vd-gap-12" }, /* @__PURE__ */ e.createElement(p, { fontSize: "h2", weight: "bold", color: "text-neutral-primary" }, r.label), /* @__PURE__ */ e.createElement(j, { question: r }))
  ), /* @__PURE__ */ e.createElement(
    S,
    {
      onClick: () => {
        g("cta", "personalisation-modal", {
          click_type: "alumni_personalised_modal_professional_find_profile_button"
        }), n("response");
      },
      buttonType: "solid",
      iconRight: "arrow-up-right",
      size: "l",
      title: "find matching profiles",
      variants: o ? "brand" : "disabled",
      disabled: !o
    }
  ));
}, Te = {
  student: /* @__PURE__ */ e.createElement(Ee, null),
  "professional-first": /* @__PURE__ */ e.createElement(Ce, null),
  "professional-second": /* @__PURE__ */ e.createElement(Fe, null)
}, Pe = () => {
  const { currentStage: t } = w();
  return Te[t];
}, P = () => /* @__PURE__ */ e.createElement(c, { direction: "column", className: "vd-p-20 sm:vd-p-28 vd-gap-y-24 sm:vd-gap-y-0 vd-bg-background-neutral-subtlest" }, /* @__PURE__ */ e.createElement(xe, null), /* @__PURE__ */ e.createElement(Pe, null)), ze = () => /* @__PURE__ */ e.createElement(c, { className: "vd-flex-col sm:vd-px-64 sm:vd-py-20 vd-justify-center vd-items-center vd-flex-1 vd-mb-16 sm:vd-mb-0" }, /* @__PURE__ */ e.createElement("img", { src: U, alt: "loading", className: "vd-h-40" }), /* @__PURE__ */ e.createElement(c, { className: "vd-mt-20 vd-flex-col vd-text-center" }, /* @__PURE__ */ e.createElement(p, { fontSize: "h1", weight: "bold", color: "text-neutral-primary" }, "Finding Alumni just like you")), /* @__PURE__ */ e.createElement(c, { className: "vd-mt-28 vd-text-center" }, /* @__PURE__ */ e.createElement(p, { fontSize: "b1", color: "text-neutral-tertiary" }, "We are analysing all the details to filter profiles similar to you. Once done you can connect with them to understand their career journey"))), Re = () => {
  var a;
  const { profile: t } = k(), { formState: n } = b(), o = (l) => typeof l == "string" ? l : l.value, r = (a = F.find(
    (l) => l.id === t
  )) == null ? void 0 : a.title;
  return /* @__PURE__ */ e.createElement(c, { className: "vd-flex-col vd-gap-28 vd-p-16 sm:vd-p-40" }, /* @__PURE__ */ e.createElement(c, { direction: "column", className: "vd-gap-12 sm:vd-w-full vd-justify-between vd-items-start sm:vd-items-center" }, /* @__PURE__ */ e.createElement(p, { fontSize: "b1", color: "text-neutral-tertiary", className: "vd-flex-1" }, "You're a"), /* @__PURE__ */ e.createElement(c, { className: "vd-bg-surface-neutral-elevate-lower vd-border-solid vd-border-border-neutral-subtle vd-py-12 vd-px-24 vd-items-center vd-self-start vd-w-156 vd-max-w-156 vd-justify-center" }, /* @__PURE__ */ e.createElement(p, { fontSize: "b1", color: "text-neutral-tertiary", className: "vd-text-center" }, r))), n.map(
    (l) => /* @__PURE__ */ e.createElement(c, { key: l.id, direction: "column", className: "vd-gap-12 sm:vd-w-full vd-justify-between vd-items-start sm:vd-items-center" }, /* @__PURE__ */ e.createElement(p, { fontSize: "b1", color: "text-neutral-tertiary", className: "vd-flex-1" }, l.label), /* @__PURE__ */ e.createElement(c, { className: "vd-bg-surface-neutral-elevate-lower vd-border-solid vd-border-border-neutral-subtle vd-py-12 vd-px-24 vd-items-center vd-self-start vd-w-156 vd-max-w-156 vd-justify-center" }, /* @__PURE__ */ e.createElement(p, { fontSize: "b1", color: "text-neutral-tertiary", className: "vd-text-center" }, o(l.isSelected))))
  ));
}, Oe = () => {
  var a;
  const { profile: t } = k(), { formState: n } = b(), o = (l) => typeof l == "string" ? l : l.value, r = (a = F.find(
    (l) => l.id === t
  )) == null ? void 0 : a.title;
  return /* @__PURE__ */ e.createElement(c, { className: "vd-flex-col vd-gap-28 vd-p-16 sm:vd-p-40" }, /* @__PURE__ */ e.createElement(c, { direction: "column", className: "vd-gap-12 vd-w-full vd-justify-between vd-items-start sm:vd-items-center" }, /* @__PURE__ */ e.createElement(p, { fontSize: "b1", color: "text-neutral-tertiary", className: "vd-flex-1" }, "You're a"), /* @__PURE__ */ e.createElement(c, { className: "vd-bg-surface-neutral-elevate-lower vd-border-solid vd-border-border-neutral-subtle vd-py-12 vd-px-24 vd-items-center vd-self-start vd-max-w-156 vd-w-156 vd-justify-center" }, /* @__PURE__ */ e.createElement(p, { fontSize: "b1", color: "text-neutral-tertiary", className: "vd-text-center" }, r))), n.map(
    (l) => /* @__PURE__ */ e.createElement(c, { key: l.id, direction: "column", className: "vd-gap-12 vd-w-full vd-justify-between vd-items-start sm:vd-items-center" }, /* @__PURE__ */ e.createElement(p, { fontSize: "b1", color: "text-neutral-tertiary", className: "vd-flex-1" }, l.label), /* @__PURE__ */ e.createElement(c, { className: "vd-bg-surface-neutral-elevate-lower vd-border-solid vd-border-border-neutral-subtle vd-py-12 vd-px-24 vd-items-center vd-self-start vd-max-w-156 vd-w-156 vd-justify-center" }, /* @__PURE__ */ e.createElement(p, { fontSize: "b1", color: "text-neutral-tertiary", className: "vd-text-center" }, o(l.isSelected))))
  ));
}, Ie = {
  student: /* @__PURE__ */ e.createElement(Re, null),
  professional: /* @__PURE__ */ e.createElement(Oe, null)
}, Le = () => {
  const { profile: t } = k();
  return /* @__PURE__ */ e.createElement(c, { className: "vd-shadow-d-32l vd-flex-col vd-p-20 sm:vd-px-32 vd-flex-1" }, /* @__PURE__ */ e.createElement(c, { className: "vd-bg-surface-neutral-elevate-low vd-p-20 vd-justify-center" }, /* @__PURE__ */ e.createElement(p, { fontSize: "h2", weight: "bold", color: "text-neutral-primary" }, "Your Response")), /* @__PURE__ */ e.createElement(c, { className: "vd-gap-y-20 vd-flex-col vd-border-solid vd-border-border-neutral-subtler" }, Ie[t]));
}, je = ({ question: t, filterOptions: n }) => {
  const { id: o, isSelected: r } = t;
  let a = o, l;
  const s = ["Computer Science", "Information Science/Information Technology"], u = n.branch.filter((d) => !s.includes(d)), i = n.pre_academy_segment.filter(
    (d) => d !== "Student or Fresher"
  );
  if (!r)
    return null;
  switch (o) {
    case "audience":
      a = "pre_academy_segment", r.value === "Student" ? l = ["Student or Fresher"] : r.value === "Professional" && (l = i);
      break;
    case "profile":
      r.value === "CS Background" ? (a = "branch", l = s) : r.value === "Non CS Profile" ? (a = "branch", l = u) : r.value === "Non Tech" && (a = "pre_scaler_role_type", l = ["Non Tech background"]);
      break;
    case "post_academy_segment":
      l = [r.value];
      break;
  }
  return [`${a}_matches_any`, l];
}, Ae = ({ question: t, filterOptions: n }) => {
  const { id: o, isSelected: r } = t;
  let a = o, l;
  const s = ["Computer Science", "Information Science/Information Technology"], u = n.branch.filter((i) => !s.includes(i));
  switch (o) {
    case "audience":
      a = "pre_academy_segment", l = ["Student or Fresher"];
      break;
    case "profile":
      r === "CS Background" ? (a = "branch", l = s) : r === "Non CS Profile" ? (a = "branch", l = u) : r === "Non Tech" && (a = "pre_scaler_role_type", l = ["Non Tech background"]);
      break;
    case "tier":
      r === "Tier 1 College" ? l = ["Tier 1"] : r === "Tier 2 College" ? l = ["Tier 2"] : r === "Tier 3 College" && (l = ["Tier 3", "Tier 4"]);
      break;
    case "post_academy_segment":
      l = [r.value];
      break;
  }
  return [`${a}_matches_any`, l];
}, De = ({ question: t, filterOptions: n }) => {
  const { id: o, isSelected: r } = t, a = o, l = ["Computer Science", "Information Science/Information Technology"], s = n.branch.filter((m) => !l.includes(m)), u = n.pre_academy_segment.filter(
    (m) => m !== "Student or Fresher"
  ), i = {};
  switch (o) {
    case "profile":
      r === "CS Background" ? i.branch = l : r === "Non CS Profile" ? i.branch = s : r === "Non Tech" && (i.branch = s, i.pre_scaler_role_type = ["Non Tech background"]);
      break;
    case "experience": {
      const [m, f] = r.value.split("-").map((v) => v.trim());
      if (f)
        i[a] = [{ min: m, max: f }];
      else {
        const v = m.split("and")[0].trim();
        i[a] = [{ min: v }];
      }
      break;
    }
    case "pre_scaler_role_type":
    case "post_scaler_role_type":
    case "post_academy_segment":
      i[a] = [r.value];
      break;
    case "pre_academy_segment":
      i[a] = [...u, r.value];
  }
  return Object.keys(i).reduce((m, f) => {
    const v = o === "experience" ? f : `${f}_matches_any`;
    return m[v] = i[f], m;
  }, {});
}, $e = ({ onRecommendationClick: t }) => {
  const { profile: n, setProfile: o } = k(), { formState: r, setFormState: a, filterOptions: l } = b(), s = _(() => {
    const i = {};
    return r.forEach((d) => {
      const [m, f] = Ae({ question: d, filterOptions: l });
      i[m] = f;
    }), i.pre_academy_segment_matches_any = ["Student or Fresher"], i;
  }, [l, r]), u = _(() => {
    const i = {};
    return r.forEach((d) => {
      const m = De({ question: d, filterOptions: l });
      Object.keys(m).forEach((f) => {
        i[f] || (i[f] = []), i[f] = [.../* @__PURE__ */ new Set([...i[f], ...m[f]])];
      });
    }), i;
  }, [l, r]);
  return E(() => {
    let i;
    return n === "student" ? i = s() : i = u(), t && t(i), () => {
      a("intro"), o(null);
    };
  }, [
    u,
    s,
    t,
    n,
    a,
    o
  ]), /* @__PURE__ */ e.createElement(c, { direction: "column", className: "vd-p-8 sm:vd-p-28 vd-bg-background-neutral-subtlest" }, /* @__PURE__ */ e.createElement(ze, null), /* @__PURE__ */ e.createElement(Le, null));
}, We = (t) => ({
  intro: /* @__PURE__ */ e.createElement(Se, { ...t }),
  student: /* @__PURE__ */ e.createElement(P, null),
  "professional-first": /* @__PURE__ */ e.createElement(P, null),
  "professional-second": /* @__PURE__ */ e.createElement(P, null),
  response: /* @__PURE__ */ e.createElement($e, { onRecommendationClick: t.onFilterRecommendationClick })
}), Be = (t) => {
  const { currentStage: n } = w();
  return E(() => {
    n && g("cta", "personalisation-modal", {
      click_type: `alumni_personalised_modal_${n}_view`
    });
  }, [n]), We(t)[n];
}, V = (t, n) => {
  const o = {};
  return t.forEach((r) => {
    const [a, l] = je({ question: r, filterOptions: n }) || [];
    a && l && (o[a] = l);
  }), o;
}, Me = ({ question: t, onQuestionChange: n }) => {
  const { filterOptions: o, formState: r, setFormState: a } = b(), { id: l, type: s, trackingName: u } = t, i = _((m) => V(m, o), [o]), d = _((m) => {
    const f = r.map((y) => y.id === l ? { ...y, isSelected: m } : y);
    g("cta", "personalisation-on-fp", {
      click_type: `alumni_on_fp_personalised_${u}`,
      click_text: (m == null ? void 0 : m.value) || m
    });
    const v = i(f);
    a(f), n(v);
  }, [i, r, l, n, a, u]);
  return /* @__PURE__ */ e.createElement(c, { className: "vd-flex-wrap sm:vd-flex-row vd-gap-x-16 vd-gap-y-16" }, s === "radio" ? Y(t, d) : H(t, d));
}, Ue = ({ attributes: t }) => /* @__PURE__ */ e.createElement(
  c,
  {
    className: `vd-flex-col vd-w-328 sm:vd-w-480 vd-border vd-border-solid
    vd-border-border-neutral-subtlest vd-shadow-d-4l`
  },
  /* @__PURE__ */ e.createElement(
    Z,
    {
      avatarUrl: t.image_url,
      avatarClass: "vd-w-104 vd-h-104 vd-object-fill",
      containerClass: "vd-w-full vd-bg-surface-neutral-base vd-h-full",
      headerClass: "vd-mb-auto",
      contentComponent: /* @__PURE__ */ e.createElement(c, { className: "vd-px-8 vd-py-16" }, /* @__PURE__ */ e.createElement(
        te,
        {
          containerClass: "vd-w-full",
          variant: "v1",
          leftTitle: "Pre Scaler",
          rightTitle: "Post Scaler",
          leftIconComponent: /* @__PURE__ */ e.createElement(
            p,
            {
              fontSize: "b1",
              color: "text-neutral-tertiary",
              className: "vd-flex vd-items-center vd-w-100 sm:vd-w-128 vd-h-40 vd-pt-4"
            },
            t.pre_academy_company
          ),
          rightIconComponent: /* @__PURE__ */ e.createElement(
            "img",
            {
              src: t.company_logo_url,
              alt: "post scaler img",
              className: "vd-w-100 sm:vd-w-128 vd-h-40 vd-pt-4"
            }
          ),
          centerIconComponet: /* @__PURE__ */ e.createElement(
            "img",
            {
              src: se,
              alt: "post scaler img",
              className: "vd-w-48 vd-h-24"
            }
          )
        }
      )),
      tagComponent: /* @__PURE__ */ e.createElement(
        q,
        {
          labelSize: "xxs",
          label: "ASK QUESTIONS",
          iconLeft: "chat-dots",
          labelVariant: "hero"
        }
      ),
      titleComponent: /* @__PURE__ */ e.createElement(c, { className: "vd-flex-col vd-gap-8" }, /* @__PURE__ */ e.createElement(p, { color: "text-neutral-primary", fontSize: "h2", weight: "bold" }, t.name), /* @__PURE__ */ e.createElement(p, { color: "text-neutral-tertiary", fontSize: "b3", weight: "bold" }, `${t.role} @ ${t.post_academy_company}`)),
      footerComponent: /* @__PURE__ */ e.createElement(c, { className: "vd-flex-row vd-gap-x-8" }, t.growth ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(p, { color: "text-alert-success-soft", fontSize: "b1", weight: "bold" }, `${t.growth} %`), /* @__PURE__ */ e.createElement(p, { color: "text-alert-success-soft", fontSize: "b1" }, "Salary Hike Post Scaler")) : /* @__PURE__ */ e.createElement(p, { color: "text-neutral-tertiary", fontSize: "b1" }, "Connect to know about Salary Hike")),
      footerContainerClass: `vd-items-center vd-justify-center vd-pt-16 vd-flex-none
        ${t.growth ? "vd-bg-background-alert-success-subtlest" : "vd-bg-surface-neutral-elevate-low"}`
    }
  )
), Qe = ({ reviewCardData: t }) => /* @__PURE__ */ e.createElement(c, { className: "vd-gap-16 sm:vd-gap-12 vd-overflow-scroll no-scrollbar" }, t.map(({ id: n, attributes: o }) => /* @__PURE__ */ e.createElement(Ue, { key: n, attributes: o }))), Ye = ({ onRecommendationClick: t }) => {
  const { formState: n, setFormState: o, filterOptions: r } = b(), [a, { isLoading: l, isSuccess: s, isError: u }] = ne(), [i, d] = x([]), [m, f] = x(null), [v, y] = x(null), N = _(async (h) => {
    const { data: T } = await a({ q: h }), { data: { data: J }, total_entries: X } = T;
    d(J), Object.keys(h).length !== 0 && (f(h), y(parseInt(X, 10)));
  }, [a]);
  E(() => {
    if (i.length === 0) {
      const h = V(n, r);
      N(h);
    }
  }, [N, r, n, i.length]);
  const G = () => {
    g("cta", "personalisation-on-fp", {
      click_type: "remove-filter-button-click"
    }), N({});
    const h = n.map((T) => ({ ...T, isSelected: null }));
    o(h), f(null), y(null);
  }, K = () => {
    if (u)
      return /* @__PURE__ */ e.createElement(I, { showButton: !1 });
    if (s)
      return /* @__PURE__ */ e.createElement(Qe, { reviewCardData: i });
    if (l)
      return /* @__PURE__ */ e.createElement(O, { className: "vd-pt-128 vd-pb-128 vd-w-full" });
  };
  return /* @__PURE__ */ e.createElement(c, { className: "vd-flex-col" }, /* @__PURE__ */ e.createElement(c, { direction: "column", className: `vd-gap-12 ${v ? "" : "vd-mb-20"}` }, n.map(
    (h) => /* @__PURE__ */ e.createElement(c, { key: h.id, className: "vd-flex-col vd-gap-12 vd-w-full" }, /* @__PURE__ */ e.createElement(Me, { question: h, onQuestionChange: N }))
  )), v !== null && /* @__PURE__ */ e.createElement(c, { className: "vd-items-center vd-justify-between" }, /* @__PURE__ */ e.createElement(p, { fontSize: "b3", color: "text-neutral-tertiary" }, "Showing All Filtered Profiles"), /* @__PURE__ */ e.createElement(
    S,
    {
      onClick: G,
      buttonType: "text",
      variants: "brand",
      size: "s",
      title: "Remove All Filters",
      upperCase: !1
    }
  )), K(), /* @__PURE__ */ e.createElement(
    S,
    {
      onClick: () => {
        g("cta", "personalisation-on-fp", {
          click_type: "alumni_on_fp_personalised_view_all_alumni"
        }), t && t(m);
      },
      buttonType: "solid",
      iconRight: "arrow-up-right",
      size: "l",
      upperCase: !1,
      title: `View All Alumni Profiles ${v ? `(${v})` : ""}`,
      variants: "brand",
      className: "vd-mt-20"
    }
  ));
}, He = (t, n) => n ? t.map((o) => ({
  ...o,
  isSelected: Ve(
    o.id,
    n,
    o.options
  )
})) : t, Ve = (t, n, o) => {
  const r = n[t];
  return r ? o.find(
    (l) => l.label.toLowerCase().includes(r.toLowerCase())
  ) : null;
}, Ge = (t) => {
  var y;
  const {
    isError: n,
    isLoading: o,
    isSuccess: r,
    refetch: a,
    onFilterRecommendationClick: l,
    prefilledValues: s
  } = t, { filterOptions: u, formState: i, setFormState: d } = b(), [
    m
  ] = C(() => u && Object.keys(u).length ? L(u, ["fp"]) : [[]], [u]);
  E(() => {
    g("cta", "personalisation-on-fp", {
      click_type: "alumni_on_fp_personalised_view"
    });
  }, []), E(() => {
    if (m) {
      const N = He(
        m,
        s
      );
      d(N);
    }
  }, [m, s, d]);
  const f = _(() => {
    a();
  }, [a]);
  if (o)
    return /* @__PURE__ */ e.createElement(O, { className: "vd-pt-128 vd-pb-128" });
  if (n)
    return /* @__PURE__ */ e.createElement(I, { onError: f });
  if (!i || i.length === 0)
    return null;
  const v = () => {
    if (r)
      return /* @__PURE__ */ e.createElement(Ye, { onRecommendationClick: l });
  };
  return /* @__PURE__ */ e.createElement(c, { className: "vd-flex-col" }, /* @__PURE__ */ e.createElement(c, { className: "vd-flex-col vd-gap-4 vd-mb-32" }, ((y = s == null ? void 0 : s.post_academy_segment) == null ? void 0 : y.length) > 0 ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(p, { fontSize: "h3", weight: "bold", color: "text-neutral-primary" }, "Meet Scaler Alumni Who Moved to ", s == null ? void 0 : s.post_academy_segment)) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(p, { fontSize: "h3", weight: "bold", color: "text-neutral-primary" }, "Find out alumni who have shared similar journey like you"), /* @__PURE__ */ e.createElement(p, { fontSize: "b3", color: "text-neutral-tertiary" }, "Now you can filter alumni profiles and can understand alumni career trajectory"))), v());
}, Ke = (t) => {
  const {
    context: n,
    onFilterRecommendationClick: o,
    userId: r,
    prefilledValues: a
  } = t, { setFilterOptions: l, setFormOriginContext: s } = b(), { data: u, isLoading: i, isFetching: d, isError: m, isSuccess: f, refetch: v } = re({}), { advance_filters: y } = (u == null ? void 0 : u.data) || {};
  return E(() => {
    ve(r), s(n);
  }, [n, s, r]), E(() => {
    y && l(y);
  }, [y, l]), n ? n === "all-filters" ? /* @__PURE__ */ e.createElement(le, null, /* @__PURE__ */ e.createElement(oe, null, /* @__PURE__ */ e.createElement(
    Be,
    {
      onFilterRecommendationClick: o,
      userId: r,
      isLoading: i || d || !1,
      isError: m || !1,
      isSuccess: f || !1,
      refetch: v
    }
  ))) : /* @__PURE__ */ e.createElement(
    Ge,
    {
      isLoading: i || d || !1,
      isError: m || !1,
      isSuccess: f || !1,
      refetch: v,
      onFilterRecommendationClick: o,
      prefilledValues: a
    }
  ) : null;
}, tt = ({
  onFilterRecommendationClick: t,
  userId: n,
  context: o = "all-filters",
  prefilledValues: r = {}
}) => /* @__PURE__ */ e.createElement(ae, null, /* @__PURE__ */ e.createElement(
  Ke,
  {
    context: o,
    onFilterRecommendationClick: t,
    userId: n,
    prefilledValues: r
  }
));
export {
  tt as default
};
